import { firebase } from './firebase'

const strage = firebase.storage()

export { strage }
